import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

export function getSocket(): Socket {
    if (!socket) {
        socket = io(process.env.REACT_APP_SERVER_URL as string, {
            withCredentials: true,
            autoConnect: false,
        });
    }
    return socket;
}
